import { render, staticRenderFns } from "./BackerCenterProjectsTabs.vue?vue&type=template&id=0451eb48"
import script from "./BackerCenterProjectsTabs.vue?vue&type=script&lang=js"
export * from "./BackerCenterProjectsTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports